var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoBlackNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg882",
    viewBox: "0 0 5.2423744 5.4232558",
    height: "5.4232559mm",
    width: "5.2423744mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs876"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140.93402,-24.522873)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forms/Text-Field/Desktop-Copy-7",
    transform: "matrix(3.017249,0,0,2.8909799,8.1750605,18.740913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/info_outline_24px",
    transform: "translate(44,2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "use22",
    d: "M 2.38125,1.3229167 H 2.9104167 V 1.8520833 H 2.38125 Z m 0,1.0583333 h 0.5291667 v 1.5875 H 2.38125 Z M 2.6458333,0 C 1.1853333,0 0,1.1853333 0,2.6458333 c 0,1.4605 1.1853333,2.6458334 2.6458333,2.6458334 1.4605,0 2.6458334,-1.1853334 2.6458334,-2.6458334 C 5.2916667,1.1853333 4.1063333,0 2.6458333,0 Z m 0,4.7625 c -1.1668125,0 -2.11666663,-0.9498542 -2.11666663,-2.1166667 0,-1.1668125 0.94985413,-2.11666663 2.11666663,-2.11666663 1.1668125,0 2.1166667,0.94985413 2.1166667,2.11666663 C 4.7625,3.8126458 3.8126458,4.7625 2.6458333,4.7625 Z",
    style: {
      strokeWidth: 0.264583
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon-info",
    d: "M 0.7818607,0.46898078 H 0.95560756 V 0.65657306 H 0.7818607 Z m 0,0.3751846 H 0.95560756 V 1.4069423 H 0.7818607 Z M 0.86873412,0 C 0.38919287,0 0,0.42020675 0,0.93796153 0,1.4557163 0.38919287,1.8759231 0.86873412,1.8759231 1.3482753,1.8759231 1.7374682,1.4557163 1.7374682,0.93796153 1.7374682,0.42020675 1.3482753,0 0.86873412,0 Z m 0,1.6883307 c -0.38311176,0 -0.6949873,-0.3367281 -0.6949873,-0.75036917 0,-0.41364104 0.31187554,-0.75036922 0.6949873,-0.75036922 0.38311168,0 0.69498728,0.33672818 0.69498728,0.75036922 0,0.41364107 -0.3118756,0.75036917 -0.69498728,0.75036917 z",
    style: {
      fill: "#000000",
      strokeWidth: 0.0902687
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlackNew);
export default __webpack_public_path__ + "static/media/info_black_new.f5f7c7bb7115242899eb905f3c91fb3f.svg";
export { ForwardRef as ReactComponent };